import { Link } from 'react-router-dom';

export default function TermsLabel() {
  return (
    <p className="f11 text-grey-dark italic mt-5">
      By proceeding you allow PawCare Inc. to charge your card for future
      payments in accordance with our{' '}
      <Link to="/terms" target="_blank">
        Terms of Service
      </Link>{' '}
      and{' '}
      <a href="/privacy.html" target="_blank">
        Privacy Policy
      </a>
      .
    </p>
  );
}
